module.exports = __webpack_public_path__ + "static/media/private.553dc663.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/usage-types/private.svg
 ** module id = 401
 ** module chunks = 0
 **/